(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buyer-imagery"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // ── Collect all lightbox media across ALL buyer-imagery sections ──
  var allMedia = [];

  function buildMediaIndex() {
    allMedia = [];
    document.querySelectorAll('[data-kbi-section]').forEach(function (section) {
      section.querySelectorAll('.kbi__item').forEach(function (item) {
        var caption = item.querySelector('.kbi__caption');
        var capText = caption ? caption.textContent.trim() : '';
        // Collect every img and video in this item
        item.querySelectorAll('.kbi__media img, .kbi__media video').forEach(function (el) {
          allMedia.push({ el: el, caption: capText, type: el.tagName.toLowerCase() });
        });
      });
    });
  }

  // ── CAROUSEL ────────────────────────────────────────────────────
  document.querySelectorAll('[data-kbi-section]').forEach(function (section) {
    var track  = section.querySelector('[data-kbi-track]');
    var prev   = section.querySelector('[data-kbi-prev]');
    var next   = section.querySelector('[data-kbi-next]');
    var dotsEl = section.querySelector('[data-kbi-dots]');
    if (!track) return;

    var items   = Array.from(track.querySelectorAll('.kbi__item'));
    var dots    = dotsEl ? Array.from(dotsEl.querySelectorAll('.kbi__dot')) : [];
    var current = 0;

    function visibleCount() {
      if (items.length === 0) return 1;
      var iw = items[0].offsetWidth + 2;
      return Math.max(1, Math.round(track.offsetWidth / iw));
    }

    function goTo(idx) {
      idx = Math.max(0, Math.min(items.length - 1, idx));
      current = idx;
      var target = items[idx];
      if (target) {
        track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - visibleCount()); });
    if (next) next.addEventListener('click', function () { goTo(current + visibleCount()); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.kbiDot, 10));
      });
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var minDist = Infinity, closest = 0;
        items.forEach(function (item, i) {
          var dist = Math.abs(item.offsetLeft - track.scrollLeft);
          if (dist < minDist) { minDist = dist; closest = i; }
        });
        if (closest !== current) {
          current = closest;
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === closest); });
        }
      }, 80);
    });
  });

  // ── INNER AUTO-SLIDERS (multi-image entries) ─────────────────────
  function initInnerSliders() {
    document.querySelectorAll('.kbi__inner-slider').forEach(function (slider) {
      var track  = slider.querySelector('.kbi__inner-track');
      var slides = Array.from(slider.querySelectorAll('.kbi__inner-slide'));
      var dots   = Array.from(slider.querySelectorAll('.kbi__inner-dot'));
      if (slides.length < 2) return;
      var cur = 0;

      function goTo(i) {
        cur = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === cur); });
      }

      setInterval(function () { goTo(cur + 1); }, 3000);
    });
  }

  // ── VIDEO inline play ────────────────────────────────────────────
  function initVideos() {
    document.querySelectorAll('.kbi__media video').forEach(function (vid) {
      var media = vid.closest('.kbi__media');
      vid.addEventListener('click', function (e) {
        e.stopPropagation(); // don't open lightbox on video click in grid
        if (vid.paused) {
          vid.play();
          if (media) media.classList.add('is-playing');
        } else {
          vid.pause();
          if (media) media.classList.remove('is-playing');
        }
      });
    });
  }

  // ── LIGHTBOX ─────────────────────────────────────────────────────
  var lb         = document.querySelector('[data-kbi-lightbox]');
  var lbStage    = lb ? lb.querySelector('[data-kbi-lb-stage]') : null;
  var lbCaption  = lb ? lb.querySelector('[data-kbi-lb-caption]') : null;
  var lbCounter  = lb ? lb.querySelector('[data-kbi-lb-counter]') : null;
  var lbPrev     = lb ? lb.querySelector('[data-kbi-lb-prev]') : null;
  var lbNext     = lb ? lb.querySelector('[data-kbi-lb-next]') : null;
  var lbCurrent  = 0;

  function lbOpen(idx) {
    if (!lb || allMedia.length === 0) return;
    lbCurrent = Math.max(0, Math.min(allMedia.length - 1, idx));
    lbRender();
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function lbClose() {
    if (!lb) return;
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lbStage) {
      var vid = lbStage.querySelector('video');
      if (vid) vid.pause();
      lbStage.innerHTML = '';
    }
  }

  function lbRender() {
    if (!lbStage) return;
    var m = allMedia[lbCurrent];
    if (!m) return;

    // Stop any playing video
    var oldVid = lbStage.querySelector('video');
    if (oldVid) oldVid.pause();
    lbStage.innerHTML = '';

    if (m.type === 'video') {
      var v = document.createElement('video');
      v.src = m.el.src || (m.el.querySelector('source') ? m.el.querySelector('source').src : '');
      v.controls = true;
      v.autoplay = true;
      v.muted = false;
      v.style.maxWidth = '100%';
      v.style.maxHeight = '70vh';
      v.addEventListener('contextmenu', function(e){ e.preventDefault(); });
      lbStage.appendChild(v);
    } else {
      var img = document.createElement('img');
      img.src = m.el.src;
      img.alt = m.el.alt || '';
      img.draggable = false;
      img.style.cssText = 'user-select:none;-webkit-user-select:none;pointer-events:none;max-width:100%;max-height:70vh;object-fit:contain;display:block;';
      lbStage.style.position = 'relative';
      lbStage.appendChild(img);
      var shield = document.createElement('div');
      shield.style.cssText = 'position:absolute;inset:0;z-index:1;background:transparent;cursor:default;';
      shield.setAttribute('aria-hidden', 'true');
      lbStage.appendChild(shield);
    }

    if (lbCaption) lbCaption.textContent = m.caption || '';
    if (lbCounter) lbCounter.textContent = (lbCurrent + 1) + ' / ' + allMedia.length;

    // Arrow visibility
    if (lbPrev) lbPrev.style.visibility = lbCurrent === 0 ? 'hidden' : 'visible';
    if (lbNext) lbNext.style.visibility = lbCurrent === allMedia.length - 1 ? 'hidden' : 'visible';
  }

  if (lb) {
    lb.querySelectorAll('[data-kbi-lb-close]').forEach(function (el) {
      el.addEventListener('click', lbClose);
    });
    if (lbPrev) lbPrev.addEventListener('click', function () {
      lbCurrent = Math.max(0, lbCurrent - 1);
      lbRender();
    });
    if (lbNext) lbNext.addEventListener('click', function () {
      lbCurrent = Math.min(allMedia.length - 1, lbCurrent + 1);
      lbRender();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'ArrowLeft') { lbCurrent = Math.max(0, lbCurrent - 1); lbRender(); }
      if (e.key === 'ArrowRight') { lbCurrent = Math.min(allMedia.length - 1, lbCurrent + 1); lbRender(); }
    });
  }

  // ── Click to open lightbox ───────────────────────────────────────
  // Images have pointer-events:none for protection.
  // The .kbi__shield sits above and receives clicks — we bind there,
  // then find the sibling img to look up the media index.
  function bindClicks() {
    document.querySelectorAll('[data-kbi-section] [data-protected]').forEach(function (mediaWrap) {
      if (mediaWrap.hasAttribute('data-has-video')) return;
      var img = mediaWrap.querySelector('img');
      if (!img) return;
      var shield = mediaWrap.querySelector('.kbi__shield');
      var target = shield || mediaWrap;
      target.style.cursor = 'zoom-in';
      target.addEventListener('click', function (e) {
        e.stopPropagation();
        buildMediaIndex();
        var idx = allMedia.findIndex(function (m) { return m.el === img; });
        if (idx !== -1) lbOpen(idx);
      });
    });
  }

  // ── IMAGE PROTECTION ─────────────────────────────────────────────
  function initProtection() {
    var section = document.querySelectorAll('[data-kbi-section]');

    section.forEach(function (sec) {
      // Block right-click on entire section
      sec.addEventListener('contextmenu', function (e) {
        e.preventDefault();
        return false;
      });

      // Block drag on images
      sec.querySelectorAll('img').forEach(function (img) {
        img.addEventListener('dragstart', function (e) {
          e.preventDefault();
          return false;
        });
      });

      // Block long-press callout on mobile (iOS)
      sec.querySelectorAll('.kbi__media').forEach(function (media) {
        media.addEventListener('touchstart', function (e) {
          // Prevent default only on images, allow video tap
          if (!media.dataset.hasVideo) {
            // Don't prevent default entirely — that would break scroll
            // Just kill the long-press save behavior via CSS touch-callout
          }
        }, { passive: true });
      });

      // Intercept keyboard shortcut save attempts (Ctrl+S, Ctrl+Shift+S)
      sec.addEventListener('keydown', function (e) {
        if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'S')) {
          e.preventDefault();
        }
      });
    });

    // Block global right-click if it targets a protected image
    document.addEventListener('contextmenu', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('kbi__protected-img')) {
        e.preventDefault();
        return false;
      }
      if (e.target && e.target.closest && e.target.closest('[data-protected]')) {
        e.preventDefault();
        return false;
      }
    });
  }

  // ── INIT ─────────────────────────────────────────────────────────
  function init() {
    buildMediaIndex();
    initInnerSliders();
    initVideos();
    bindClicks();
    initProtection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on theme editor section updates
  document.addEventListener('shopify:section:load', function () {
    setTimeout(function () { init(); }, 100);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
